export default "__VITE_ASSET__DVDrvPof__"